var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"position-fixed page-loading"},[_c('div',{staticClass:"loader position-absolute"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin"})])]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }